<tmo-container-holder
  scId="SC1135"
  [id]="aemId"
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
></tmo-container-holder>
